import { translate } from 'localizations';
import { AccessRights } from 'store/user/user.types';
import { OptionType } from 'components/common/Selects/LabelSelect/LabelSelect';
import { useMemo } from 'react';
import { useAppSelector } from './redux';

/*
		isSingleCall - действия для одного звонка или нет
		isSettingsActions - действия на странице настроек
	*/

const useCallsActions = (accessRights: AccessRights | null, isSingleCall = false, isSettingsActions = false) => {
	const language = useAppSelector((state) => state.lang.language);

	const actionsTranslations = [
		{ value: 'swap_channels', label: translate('swapChannels', language) },
		{ value: 'get_api_tags', label: translate('getApiTags', language) },
		{ value: 'apply_notify_rules', label: translate('applyNotifyRules', language) },
		{ value: 'apply_addressbook_tags', label: translate('applyAddressbookTags', language) },
		{ value: 'editNotificationRule', label: translate('editNotificationRule', language) },
		{ value: 'stt', label: translate('stt', language) },
		{ value: 'analyze', label: translate('applyAnalyze', language) },
		{
			value: 'delete',
			label: isSingleCall ? translate('deleteCall', language) : translate('deleteCalls', language),
		},
	];

	const userActionsArray = useMemo((): OptionType[] => {
		const actionsArray = [];
		if (accessRights) {
			if (accessRights.retag) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'swap_channels'));
				actionsArray.push(actionsTranslations.find((item) => item.value === 'get_api_tags'));
			}
			if (accessRights.notify) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'apply_notify_rules'));
			}
			if (accessRights.address_book) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'apply_addressbook_tags'));
			}
			if (accessRights.restt) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'stt'));
			}
			if (accessRights.retag && isSettingsActions) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'analyze'));
			}
			if (accessRights.notify && isSingleCall) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'editNotificationRule'));
			}
			if (accessRights.delete_call) {
				actionsArray.push(actionsTranslations.find((item) => item.value === 'delete'));
			}
		}
		// @ts-ignore
		return actionsArray;
	}, [accessRights]);

	return { userActionsArray };
};
export default useCallsActions;
